<template>
  <CBreadcrumb class="d-md-down-none me-auto mb-0">

    
    <strong class="welcome-text"> {{getUserAccountName}} {{getUser.userName}}님 안녕하세요 </strong>
    <!--<CBreadcrumbItem
      v-for="item in breadcrumbs"
      :key="item"
      :href="item.active ? '' : item.path"
      :active="item.active"
    >
      {{ item.name }}
    </CBreadcrumbItem>-->
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import router from '@/router'
import { mapGetters } from 'vuex'

export default {
  name: 'AppBreadcrumb',
  data() {
    return {
    }
  },
  setup() {
    const breadcrumbs = ref()

    const getBreadcrumbs = () => {
      return router.currentRoute.value.matched.map((route) => {
        return {
          active: route.path === router.currentRoute.value.fullPath.split('?')[0],
          name: route.name,
          path: `${router.options.history.base}${route.path}`,
        }
      })
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
  computed: {
    ...mapGetters(['getUser','getUserAccountName']),
  },
}
</script>
